// TODO: Max 1 class
import { isEmptyObject } from 'jquery';
import { findIndex, isEmpty, isUndefined, isObject } from 'lodash';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import * as React from 'react';
import { browserHistory as history } from 'react-router';

import Content from './Content';
import CommentModal, { PdErrors } from './modal/CommentModal';
import ConfirmModal from './modal/ConfirmModal';
import LastComment from './modal/LastComment';
import PersonalData from './PersonalData';
import Progress, { countProgress } from './Progress';
import Sidebar from './Sidebar';

import { IGroupSchema } from '../libs/controls/Group';
import { IPanelSchema } from '../libs/controls/Panel';
import {
  ControlErrorListItem,
  IControlError,
  IControlSchema,
} from './Controls';
import { ISectionSchema } from './Section';

import {
  ControlValueDispatcher,
  ValidationError,
} from '../libs/helpers/Dispatcher';
import ApiClientModule from '../services/ApiClientModule';
import Preloader from './Preloader';
import { calcPercentSidebar } from './validation/calculate';
import { getSelection, visibleControls } from './validation/handling';
import {
  ErrorField,
  isGroupCheck,
  onValidate,
  validateControl,
} from './validation/validate';
import {
  scrollPosition,
  scrollToField,
  initLanguage,
  parseFloatCommaDot,
  roundCurrency,
  notify as utilNotify,
  confirm as utilConfirm,
} from '../libs/helpers/Utils';
import { DefaultState, Props, RequestProps, State } from '../types/coreTypes';
import { detailObject } from '../libs/controls/ButtonSet/interfaces';

// eslint-disable-next-line @typescript-eslint/no-empty-function
function nope<T extends object>(_value: T): void {}

class Request extends React.Component<Props & RequestProps, State> {
  private dispather: ControlValueDispatcher;

  modal: CommentModal;

  lastComment: LastComment;

  confirmModal: ConfirmModal;

  state = {
    ...DefaultState,
  };

  componentDidUpdate(prevProps: Readonly<Props & RequestProps>): void {
    const { process_id } = this.props.params;
    this.scrollToField();

    if (prevProps.schema.status !== this.props.schema.status) {
      this.props?.getHistory(process_id);
    }

    if (this.props.schema.section !== prevProps.schema.section) {
      this.clearAnchor();
    }
  }

  // TODO: ESLint: componentWillMount is deprecated since React 16.9.0,
  //  use UNSAFE_componentWillMount instead, see https://reactjs.org/docs/react
  // eslint-disable-next-line react/no-deprecated
  componentWillMount() {
    const {
      params: { process_id, form_type },
    } = this.props;

    initLanguage('RU');

    this.dispather = new ControlValueDispatcher();
    this.dispather.addControlValue = this.addControlValue.bind(this);
    this.dispather.addFile = this.addFileValue.bind(this);
    this.dispather.addControlRefresh = this.addControlRefresh.bind(this);
    this.dispather.gridRefreshValue = this.gridRefreshValue.bind(this);
    this.dispather.copyValue = this._handlerCopyValue.bind(this);
    this.dispather.error = this.frontError.bind(this);
    this.dispather.controlVisited = this.controlVisited.bind(this);
    this.dispather.pullValue = this.pullValue.bind(this);
    this.dispather.pullControlSchema = this.pullControlSchema.bind(this);
    this.dispather.pullTableRows = this.pullTableRows.bind(this);
    this.dispather.setDynamicOption = this.props?.setDynamicOption
      ? this.props?.setDynamicOption
      : nope;
    this.dispather.setErrors = this.setErrors.bind(this);
    this.dispather.notify = this.notify.bind(this);
    this.dispather.confirm = this.confirm.bind(this);
    this.dispather.onUpdateForm = this.actionRefreshForm;

    this.props.loadFrom(form_type, process_id);
    this.props?.getHistory(process_id);
  }

  notify = (message) => {
    let clearedMessage;

    // Если все таки понадобится обработка фронтенд ошибок, и вывод их в модалке, надо помнить что у нас
    //  Уведомления понимают только текст, верстку, и массив. В случае с группами мы получаем объект с объектами.
    //  и надо будет обойти дерево в глубину, и привести в красивый вид
    //is object
    // if(typeof message === 'object' && !message.length && message) {
    // 	clearedMessage = Object.keys(message).reduce((acc, item) => {
    // 		return [
    // 			...acc,
    // 			message[item]
    // 		]
    // 	}, []);
    // }
    // console.log(clearedMessage);

    if (this.props.notify) {
      this.props.notify(message);
    } else {
      utilNotify(message);
    }
  };

  confirm = (message, accept, header = 'Внимание!') => {
    if (this.props.confirm) {
      this.props.confirm(message, accept);
    } else {
      utilConfirm(message, accept, header);
    }
  };

  scrollToField = (customScrollPosition?: scrollPosition, otherProps = {}) => {
    this.setState((state) => {
      const anchorTo = customScrollPosition ?? state.anchorTo;
      const anchoredTo = scrollToField({
        scrollPositionTo: anchorTo,
        scrollPositionCurrent: state.anchoredTo,
      });
      if (anchoredTo) {
        return { ...state, ...otherProps, anchorTo, anchoredTo };
      }
    });
  };

  // TODO: Удалить если не нужен
  // private findSection(controlId: string): IControlSchema | undefined {
  // 	return this.props.schema.form.sections.find((s) => !!s.controls.find((c) => c.id === controlId));
  // }

  // TODO: Не используется
  // protected tr: (message: Utils.I18NString) => string = tr;

  onAddition = () => {
    const {
      api,
      schema: { form, values },
    } = this.props;
    const section = form.sections.find((t) => t.id === 'AdditionalRequest');

    const validationResult = this.validateSection(section, form, values, true);
    if (validationResult && validationResult.length > 0) {
      this.setMultipleErrors(validationResult);
      const actualErrors = validationResult.filter((v) => !!v.error);
      if (actualErrors[0]) {
        this.scrollToSectionError(actualErrors[0], section.id);
        return;
      }
    }

    this.setState({ loader: true });
    api.sendAdditional({
      success: () => {
        this.setState({ loader: false });
        this.notify('Дозапрос отправлен');
        history.push('/');
      },
      error: (error, response) => {
        this.setState({ loader: false });
        if (!isUndefined(response)) {
          const result = JSON.parse(response);
          this.notify(result.errors[0].error.message);
        } else {
          this.notify('Не удалось выполнить отправку');
        }
      },
    });
  };

  // eslint-disable-next-line react/sort-comp
  onSelected = (id: string) => {
    this.props.setSection(id);
  };

  onSetSectionForIndex = (index, shouldIncludeHidden = false) => {
    const { sections } = this.props;
    const sectionsNeeded = shouldIncludeHidden
      ? sections
      : sections.filter((sect) => !sect.hidden);
    const sectionId = sectionsNeeded?.[index].id;

    this.props.setSection(sectionId);
  };

  // eslint-disable-next-line react/sort-comp
  getCheckedPanels = (): Array<string> => {
    const {
      schema: { form, values },
    } = this.props;
    const arr = [];
    // eslint-disable-next-line no-restricted-syntax
    for (const section of form.sections) {
      // eslint-disable-next-line no-restricted-syntax
      for (const control of section.controls) {
        if (Object.prototype.hasOwnProperty.call(control, 'controls')) {
          const valueIdx = findIndex(
            values,
            (val: any) => val.controlid === control.id,
          );
          if (
            isGroupCheck(
              control as IGroupSchema | IPanelSchema,
              values[valueIdx],
            )
          ) {
            arr.push(control.id);
          }
        }
      }
    }
    return arr;
  };

  private viewErrorsAfterResponse = (fieldErrors) => {
    Object.keys(fieldErrors)?.forEach((key) => {
      // TODO: пересмотреть условие
      // eslint-disable-next-line no-nested-ternary
      const message = fieldErrors?.[key]?.[0]?.message
        ? fieldErrors?.[key]?.[0]?.message
        : Array.isArray(fieldErrors?.[key]) && fieldErrors?.[key]?.[0]
        ? fieldErrors?.[key]?.[0]
        : fieldErrors?.[key];

      this.props.setError(key, {
        isFrontValidation: true,
        isError: true,
        message,
      });
    });
  };

  onApplicationPdfDownload = async (onSuccess: () => void) => {
    const {
      api,
      schema: { values },
    } = this.props;

    this.props.markAllVisited();
    const sct = visibleControls(this.props.schema);
    if (!this.validateForm(sct, values, true)) return;

    onSuccess();
  };

  /* Отправить документы */
  onDocument = (
    property: {
      comment?: boolean;
      personal?: boolean;
      title?: string;
      sendType?: string;
      returnUrl?: string;
      callback?: any;
      formKind?: number;
      notifyMessage?: string;
      trailingSlash?: boolean;
    } = {},
  ) => {
    const {
      api,
      schema: { values },
      extRules: { PAGINATION },
    } = this.props;

    const {
      returnUrl = '/',
      formKind,
      callback,
      notifyMessage,
      trailingSlash,
    } = property;

    this.props.markAllVisited();
    const sct = visibleControls(this.props.schema);
    if (!this.validateForm(sct, values, true)) {
      return;
    }

    const func = (form?: any) => {
      this.setState({
        loader: true,
        pd_field_errors: null,
      });
      api.sendDocument(
        {
          success: () => {
            if (PAGINATION) {
              const { page, pagesize } = PAGINATION;

              this.props.getForms({
                page,
                pagesize,
                formKind,
              });
            } else {
              this.props.getForms({ formKind });
            }
            this.setState({ loader: false });
            this.notify(notifyMessage || 'Документы отправлены');

            if (callback) {
              callback();
            } else {
              history.push(`${returnUrl}/`);
            }
          },
          // @ts-ignore
          error: (error, response, redirectUrl) => {
            if (error === 404) {
              window.location.href = `${window.location.origin}/${redirectUrl}`;
            }

            this.setState({ loader: false });
            if (!isUndefined(response)) {
              try {
                const result = JSON.parse(response);

                if (result?.pd_field_errors) {
                  this.setState({ pd_field_errors: result.pd_field_errors });
                }

                if (typeof result.message !== 'undefined') {
                  this.notify(result.message);
                }

                if (
                  typeof result.detail !== 'undefined' &&
                  typeof result.detail === 'string'
                ) {
                  this.notify(result.detail);
                }
                if (typeof result.field_errors !== 'undefined') {
                  this.modal?.onClose();
                  this.viewErrorsAfterResponse(result.field_errors);
                  this.validateForm(sct, values, false);
                }

                if (typeof result?.detail?.field_errors !== 'undefined') {
                  this.modal?.onClose();
                  this.viewErrorsAfterResponse(result.detail.field_errors);
                  this.validateForm(sct, values, false);
                }
              } catch (error_) {
                const errorResp = JSON.parse(response);

                if (typeof errorResp.field_errors !== 'undefined') {
                  this.notify('Не удалось выполнить отправку');
                  this.validateForm(sct, values, true);
                }
                this.notify('Не удалось выполнить отправку');
              }
            } else {
              this.notify('Не удалось выполнить отправку');
            }
          },
        },
        form,
        property?.sendType,
        trailingSlash,
      );
    };

    if (property?.comment || property?.personal) {
      this.setState({ func });
      this.modal.show(property?.personal, property?.comment, property?.title);
    } else {
      func();
    }
  };

  /* Отозвать заявку */
  /*
   * ЕСЛИ пользователь ментор, старший ментор, или специалист, возвращаться должен в свой ЛК.
   *  extRules?.MENTORS_URL - тут должен лежать путь до его ЛК
   * ЕСЛИ указан явно customLink то кидаем его туда
   * ЕСЛИ ничего не указано и вам надо просто вернуть его в обычный список заявок,
   *  то ненадо писать customLink: '/regm/',
   *  просто укажите в extRules?.URL_PREFIX - тут префикс и все
   * */
  onReturn = (props: { customLink?: string; formKind?: number }) => {
    const {
      schema: { user },
    } = this.props;

    // const {
    // 	extRules: {
    // 		PAGINATION: { page, pagesize },
    // 		URL_PREFIX,
    // 		MENTORS_URL,
    // 	},
    // } = this.props;
    const { extRules } = this.props;
    const { page, pagesize } = extRules;

    if (
      (user.is_mentor || user.is_specialist || user.is_master_mentor) &&
      extRules?.MENTORS_URL
    ) {
      history.push(`${extRules?.MENTORS_URL}/`);
    } else {
      this.props.getForms({
        page,
        pagesize,
        formKind: props?.formKind,
      });

      if (props?.customLink && typeof props.customLink === 'string') {
        history.push(`${props.customLink}/`);
      } else {
        history.push(`${extRules?.URL_PREFIX}/`);
      }
    }
  };

  /* Отозвать заявку */
  onRevoke = (comment?: boolean, personal?: boolean, title?: string) => {
    const {
      api,
      schema: { values },
      extRules: { PAGINATION },
    } = this.props;

    this.props.markAllVisited();
    const sct = visibleControls(this.props.schema);
    if (!this.validateForm(sct, values, true)) {
      return;
    }

    const func = (form?: any) => {
      this.setState({ loader: true });
      api.sendRevoke(
        {
          success: () => {
            const { page, pagesize } = PAGINATION;

            this.props.getForms({
              page,
              pagesize,
            });
            this.setState({ loader: false });
            this.notify('Документы отправлены');
            history.push('/');
          },
          error: (error, response) => {
            this.setState({ loader: false });
            if (!isUndefined(response)) {
              try {
                const result = JSON.parse(response);
                if (typeof result.message !== 'undefined') {
                  this.notify(result.message);
                }

                if (typeof result?.field_errors !== 'undefined') {
                  this.modal?.onClose();

                  this.viewErrorsAfterResponse(result.field_errors);
                  this.validateForm(sct, values, false);
                }
              } catch (error_) {
                this.notify('Не удалось выполнить отправку');
              }
            } else {
              this.notify('Не удалось выполнить отправку');
            }
          },
        },
        form,
      );
    };
    if (typeof comment === 'boolean' || typeof personal === 'boolean') {
      this.setState({ func });
      this.modal.show(personal, comment, title);
    } else {
      func({
        comment,
      });
    }
  };

  /* Получить PDF */
  onReportPDF = () => {
    this.props.recal();
    this.props.markAllVisited();

    // TODO: Check for what this data get by store.getState()
    const { setError, setSection, incrimentToSend, schema, api } = this.props;

    const sct = visibleControls(schema);
    if (!this.validateForm(sct, schema.values)) {
      return;
    }

    const action = (open) => {
      if (open) {
        this.setState({ loader: true });
        api.sendPDF({
          success: () => {
            this.setState({ loader: false });
            this.notify('Ваш запрос на формирование PDF обрабатывается');
            history.push('/');
          },
          error: (_, response) => {
            this.setState({ loader: false });
            if (!isUndefined(response)) {
              const result = JSON.parse(response);
              if (result.errors[0].error.SumGrant) {
                setError('SumGrant', {
                  isFrontValidation: false,
                  message: result.errors[0].error.SumGrant,
                  isError: true,
                });
                setSection('GeneralInformation');
                incrimentToSend();
              } else {
                this.notify(result.errors[0].error.message);
              }
            } else {
              this.notify('Не удалось выполнить отправку');
            }
          },
        });
      }
    };
    this.setState({ func: action });
    // this.modal.show();
  };

  onLoadPDF = () => {
    this.props.markAllVisited();
    const {
      schema,
      api,
      extRules: { PDF_URL },
    } = this.props;

    const sct = visibleControls(schema);

    api.loadPDF({
      success: () => {
        const a = document.createElement('a');
        a.href = `${PDF_URL}/${schema.process_id}`;
        a.download = schema.process_id.toString();

        a.click();
      },
      error: (error, response) => {
        if (!isUndefined(response)) {
          try {
            const result = JSON.parse(response);

            if (result?.field_errors) {
              this.setState({ pd_field_errors: result.field_errors });
            }

            if (typeof result.message !== 'undefined') {
              this.notify(result.message);
            }

            if (typeof result.field_errors !== 'undefined') {
              this.modal?.onClose();
              this.validateForm(sct, schema.values, false);
            }
          } catch (error_) {
            const errorResp = JSON.parse(response);

            if (typeof errorResp.field_errors !== 'undefined') {
              this.notify('Не удалось скачать PDF');
              this.validateForm(sct, schema.values, true);
            }
            this.notify('Не удалось выполнить загрузку');
          }
        } else {
          this.notify('Не удалось выполнить загрузку');
        }
      },
    });
  };

  onLoadContract = () => {
    this.props.markAllVisited();
    const {
      schema,
      api,
      extRules: { CONTRACT_URL },
    } = this.props;

    const sct = visibleControls(schema);

    api.loadContract(schema.process_id, {
      success: () => {
        const a = document.createElement('a');
        a.href = `${CONTRACT_URL}${schema.process_id}/contract`;
        a.download = schema.process_id.toString();

        a.click();
      },
      error: (error, response) => {
        if (response) {
          const result = JSON.parse(response);

          if (result?.field_errors) {
            this.setState({ pd_field_errors: result.field_errors });
            this.modal?.onClose();
            this.validateForm(sct, schema.values, false);
          }
        } else {
          this.notify('Не удалось выполнить загрузку проекта соглашения');
        }
      },
    });
  };

  onDelete = () => {
    const { api } = this.props;
    this.confirm('Удалить заявку?', () => {
      this.setState({ loader: true });
      api.deleteValues({
        success: () => {
          this.setState({ loader: false });
          history.push('/');
        },
        error: () => {
          this.setState({ loader: false });
          this.notify('Произошла ошибка в во время удаления заявки');
        },
      });
    });
  };

  onCopy = () => {
    const { api } = this.props;

    this.confirm('Копировать заявку?', () => {
      this.setState({ loader: true });
      api.cloneRequest({
        success: () => {
          this.setState({ loader: false });
          history.push('/');
        },
        error: () => {
          this.setState({ loader: false });
          this.notify('Произошла ошибка в во время копирования заявки');
        },
      });
    });
  };

  // eslint-disable-next-line react/sort-comp
  gridRefreshValue = (controlId: string) => {
    this.props.refreshValue(controlId);
  };

  addControlValue = (
    id: string,
    value: any,
    valid: boolean,
    error: ValidationError,
    opts?: any,
    action?: string,
  ) => {
    this.checkAndSetControlErrors(id, value, error, false, opts);
    this.props.addValue(id, value, false, action);
  };

  addControlRefresh = (id: string, value: any, error: ValidationError) => {
    this.checkAndSetControlErrors(id, value, error, false);
    this.props.addValue(id, value, true);
  };

  _handlerCopyValue = (sourceId: string, targetId: string) => {
    this.props.copyValue(sourceId, targetId);
  };

  onValidateAndSend = () => {
    this.props.recal();
    this.props.markAllVisited();

    // TODO: Check for what this data get by store.getState()
    const { schema, api } = this.props;
    const { values } = schema;

    const sct = visibleControls(schema);
    if (!this.validateForm(sct, values, true)) {
      return;
    }

    const action = (open) => {
      if (open) {
        this.setState({ loader: true });
        api.sendValues({
          success: () => {
            this.setState({ loader: false });
            this.notify('Ваша заявка принята');
            history.push('/');
          },
          error: (error, response) => {
            this.setState({ loader: false });
            if (!isUndefined(response)) {
              const result = JSON.parse(response);
              if (result.errors[0].error.SumGrant) {
                this.props.setError('SumGrant', {
                  isFrontValidation: false,
                  message: result.errors[0].error.SumGrant,
                  isError: true,
                });

                this.props.setSection('GeneralInformation');
                this.props.incrimentToSend();
              } else {
                this.notify(result.errors[0].error.message);
              }
            } else {
              this.notify('Не удалось выполнить отправку');
            }
          },
        });
      }
    };
    this.setState({ func: action });
    // this.modal.show();
  };

  // TODO: Check and clean for usability
  private validateSection = (
    section: any,
    all_sections: Array<any>,
    form: any,
    values,
    enabledControlsOnly = false,
  ): ErrorField[] => {
    let errorFields = Array.from(
      onValidate(
        section.controls,
        values,
        form,
        true,
        this.props.schema.errors,
      ),
    );

    if (enabledControlsOnly) {
      errorFields = errorFields.filter(
        (errorField) => !errorField.control.disabled,
      );
    }

    if (section.id === 'second') {
      errorFields = errorFields.filter(
        (errorField) => errorField.control.required || errorField.control.value,
      );
    }

    if (section.id === 'BusinessModel') {
      const years = [
        '2017',
        '2018',
        '2019',
        '2020',
        '2021',
        '2022',
        '2023',
        '2024',
        '2025',
        'Total',
      ];
      const sum_8_2 = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      const sum_8_3 = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      let error_ctrl_8 = null;
      let data_avali = true;
      // eslint-disable-next-line no-restricted-syntax
      for (const control of section.controls) {
        if (control.id === 'SalesYear') {
          error_ctrl_8 = control;
          const sales_value =
            typeof control.value === 'string'
              ? JSON.parse(control.value)
              : control.value;
          if (sales_value) {
            // eslint-disable-next-line no-restricted-syntax
            for (const v1 of sales_value) {
              if (v1.spec_summary) {
                continue;
              }
              for (let i = 0; i < years.length; i++) {
                if (v1[`sale${years[i]}`]) {
                  const cur = parseFloatCommaDot(v1[`sale${years[i]}`]);
                  if (!Number.isNaN(cur)) {
                    sum_8_2[i] += cur;
                  }
                }
              }
            }
          } else {
            data_avali = false;
          }
        }
        if (control.id === 'SalesCountry') {
          const sales_value =
            typeof control.value === 'string'
              ? JSON.parse(control.value)
              : control.value;
          if (sales_value) {
            // eslint-disable-next-line no-restricted-syntax
            for (const v2 of sales_value) {
              if (v2.spec_summary) {
                continue;
              }
              for (let i = 0; i < years.length; i++) {
                let field = `sale${years[i]}country`;
                if (years[i] === 'Total') {
                  field = 'saleTotalCountry';
                }
                if (v2[field]) {
                  const cur = parseFloatCommaDot(v2[field]);
                  if (!Number.isNaN(cur)) {
                    sum_8_3[i] += cur;
                  }
                }
              }
            }
          } else {
            // TODO: не понятная переменная
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            data_avali = false;
          }
        }
      }
      for (let i = 0; i < years.length; i++) {
        sum_8_2[i] = roundCurrency(sum_8_2[i]);
        sum_8_3[i] = roundCurrency(sum_8_3[i]);
        if (sum_8_2[i] !== sum_8_3[i]) {
          let name_part = years[i];
          if (name_part === 'Total') {
            name_part = 'Итого';
          }
          errorFields.push({
            controlId: 'SalesYear',
            control: error_ctrl_8,
            error: {
              message: `Внимание! Проверьте итоговые значения по столбцам в таблицах “Факт и Прогноз продаж по направлениям” и "Факт и Прогноз продаж по странам”, они должны совпадать (${name_part})`,
              isFrontValidation: true,
            },
          });
          return errorFields;
        }
      }

      errorFields = errorFields.filter(
        (item) => item.controlId !== 'SalesYear',
      );
    }
    return errorFields;
  };

  private validateForm = (
    form: any,
    values,
    enabledControlsOnly = false,
  ): boolean => {
    let firstInvalidSection: { sectionId: string; errorField: ErrorField };
    const { pd_field_errors } = this.state;

    if (pd_field_errors) {
      const fieldsArray = Object.keys(pd_field_errors);
      const firstErrorField = [];

      // eslint-disable-next-line guard-for-in,no-restricted-syntax
      for (const section in form) {
        const field = form[section].controls.find((control) =>
          fieldsArray.includes(control.id),
        );

        if (field) {
          firstErrorField.push(form[section].id, {
            controlId: field.id,
            control: field,
            error: {
              message:
                pd_field_errors?.[field.id]?.[0]?.message ||
                pd_field_errors?.[field.id],
              isFrontValidation: true,
            },
          });
          break;
        }
      }
      this.setMultipleErrors([firstErrorField[1]]);
      firstInvalidSection = {
        sectionId: firstErrorField[0],
        errorField: firstErrorField[1],
      };
    } else {
      // eslint-disable-next-line guard-for-in,no-restricted-syntax
      for (const section in form) {
        const validationErrors = this.validateSection(
          form[section],
          form,
          form,
          values,
          enabledControlsOnly,
        );
        if (validationErrors) {
          this.setMultipleErrors(validationErrors);
          const realErrors = validationErrors.filter((e) => e.error);

          if (realErrors.length > 0 && !firstInvalidSection) {
            firstInvalidSection = {
              sectionId: form[section].id,
              errorField: realErrors[0],
            };
          }
        }
      }
    }

    if (firstInvalidSection) {
      this.scrollToSectionError(
        firstInvalidSection.errorField,
        firstInvalidSection.sectionId,
      );
      return false;
    }

    return true;
  };

  private isPdf = (): boolean => {
    const { values } = this.props.schema;
    const requestPdf = findIndex(
      values,
      (obj: any) => obj.controlid === 'RequestGrant',
    );

    return requestPdf > -1;
  };

  private findControlInArray = (
    controlId: string,
    controls: any[],
  ): IControlSchema | undefined => {
    return controls
      .map((c) => {
        if (c.id === controlId) {
          return c;
        }
        if (c.controls) {
          return this.findControlInArray(controlId, c.controls);
        }

        // TODO: Уточнить с решением ошибки?! <TextBox /> или переделать json -> controls?
        if (c.type === 'Group') {
          return this.findControlInArray(controlId, c.columns);
        }

        return undefined;
      })
      .find((s) => s);
  };

  private findControl = (controlId: string): IControlSchema | undefined => {
    return this.props.schema.form.sections
      .map((s) => this.findControlInArray(controlId, s.controls))
      .find((s) => s);
  };

  private clearAnchor = () => {
    this.setState({
      anchoredTo: {
        sectionId: undefined,
        controlId: undefined,
      },
      anchorTo: {
        sectionId: undefined,
        controlId: undefined,
      },
    });
  };

  onConfirmProcess = (accept: boolean) => {
    const {
      schema: { process_id },
      onAcceptMentorProcess,
    } = this.props;

    if (!accept) {
      this.confirmModal.show();
    } else {
      onAcceptMentorProcess(String(process_id), accept, null);
    }
  };

  controlVisited = (id: string) => {
    this.props.markVisited(id);
  };

  pullValue = (control_id: string) => {
    const values = this.props.schema.values.filter(
      (v) => v.controlid === control_id,
    );
    if (!isEmpty(values)) {
      return values[0].value;
    }
    return null;
  };

  pullControlSchema = (control_id: string) => {
    const values = this.props.schema.form.sections
      .find((item) => item.id === this.props.schema.section)
      ?.controls.filter((v) => v.id === control_id);
    if (!isEmpty(values)) {
      return values[0];
    }
    return null;
  };

  pullTableRows = (control_id: string, field_id: string): Array<string> => {
    const values = this.props.schema.values.filter(
      (v) => v.controlid === control_id,
    );
    if (!isEmpty(values)) {
      try {
        const array =
          typeof values[0].value === 'string'
            ? JSON.parse(values[0].value)
            : values[0].value;
        return array.map((obj) => obj[field_id]);
      } catch (error) {
        return [];
      }
    }
    return [];
  };

  frontError = (
    id: string,
    value: string,
    error: ValidationError | undefined,
    skipCommonValidation: boolean,
  ) => {
    const control = this.findControl(id);
    const {
      schema: { errors },
      setError,
    } = this.props;

    if (!control) {
      console.error(`control with id ${id} was not found`);
      return;
    }

    const existingError = errors[control.id];
    if (existingError && !existingError.isFrontValidation) {
      return;
    }

    if ((control as any).disabled && !control.visible) {
      setError(id, undefined);
      return;
    }

    if (!error && !skipCommonValidation) {
      this.checkAndSetControlErrors(id, value, error, false);
      return;
    }

    setError(
      id,
      error && {
        isFrontValidation: true,
        message: error.message,
        isError: true,
      },
    );
  };

  checkAndSetControlErrors = (
    id: string,
    value: any,
    error: ValidationError,
    validateEmptyRequired: boolean,
    opts?: any,
  ) => {
    let errors: ErrorField[] = [];
    if (!error || !error?.message) {
      errors = this.checkForErrors(
        id,
        value,
        error,
        validateEmptyRequired,
        opts,
      );
      if (errors.filter((e) => e.controlId === id).length <= 0) {
        errors.push({
          controlId: id,
          control: this.findControl(id),
          error: undefined,
        });
      }

      if (['SumGrant', 'FixedTableEstimate'].includes(id)) {
        const controlId = id === 'SumGrant' ? 'FixedTableEstimate' : 'SumGrant';
        errors.push({
          controlId,
          control: this.findControl(controlId),
          error: undefined,
        });
      }
    } else {
      errors.push({
        controlId: id,
        control: this.findControl(id),
        error: {
          isFrontValidation: true,
          message: error.message,
        },
      });
    }

    // TODO: Из-за setState in Loop - отваливается приложение -> передается в контент и на этом все
    //  Временно закомментил - надо тестировать
    // this.setState({ errorField: errors.find((e) => !!e.error) });
    this.setMultipleErrors(errors);
  };

  checkForErrors = (
    id: string,
    value: any,
    error: ValidationError,
    validateEmptyRequired: boolean,
    opts?: any,
  ): ErrorField[] => {
    const control = this.findControl(id);
    const { schema } = this.props;

    if (control) {
      const values = schema.values.filter((v) => v.controlid !== id);
      if (!isEmpty(value)) {
        values.push({
          controlid: id,
          value,
        });
      }
      const controlError: IControlError = error && {
        isError: true,
        isFrontValidation: true,
        message: error.message,
      };
      const existingErrors = {
        ...schema.errors,
        [id]: controlError,
      };
      return Array.from(
        validateControl(
          {
            ...control,
            value,
          } as any,
          values,
          schema.form,
          validateEmptyRequired,
          existingErrors,
          opts,
        ),
      );
    }
    return [];
  };

  setMultipleErrors = (errorFields: ErrorField[]) => {
    const { setError } = this.props;
    errorFields.forEach((e) =>
      setError(
        e.controlId,
        e.error && {
          isFrontValidation: true,
          isError: true,
          message: e.error.message,
        },
      ),
    );
  };

  setErrors = (errors: any) => {
    const {
      schema: { values },
    } = this.props;

    this.props.markAllVisited();
    const sct = visibleControls(this.props.schema);

    this.viewErrorsAfterResponse(errors);
    this.validateForm(sct, values, false);
  };

  addFileValue = (id: string, value: any) => {
    const { errorField } = this.state;

    if (errorField && errorField.controlId === id) {
      this.setState({ errorField: undefined });
    }
    this.props.addFile(id, value);
  };

  collectSectionErrors = (section: ISectionSchema): ControlErrorListItem[] => {
    if (!section) {
      return [];
    }
    const {
      schema: { errors },
    } = this.props;

    function* collectErrors(
      controls: IControlSchema[],
    ): Iterable<ControlErrorListItem> {
      // eslint-disable-next-line no-restricted-syntax
      for (const control of controls) {
        const controlError = errors[control.id];
        if (controlError) {
          const error: ControlErrorListItem = {
            ...controlError,
            controlId: control.id,
          };
          yield error;
        }

        if ((control as any).controls) {
          yield* collectErrors((control as any).controls);
        }
      }
    }

    return Array.from(collectErrors(section.controls));
  };

  // eslint-disable-next-line consistent-return
  findSectionByControl = (controlId: string) => {
    if (this.props?.schema?.form?.sections) {
      return this.props.schema.form.sections.find(
        (section) =>
          !!section.controls.find((control) => control.id === controlId),
      );
    }
  };

  actionScrollToField = (controlId: string, refresh: boolean) => {
    const { setSection } = this.props;
    if (refresh) {
      this.actionRefreshForm();
    }
    // TODO Нет возможности получить флаг о завершении обновления формы, потом доработать
    const intervalId = setInterval(() => {
      const section = this.findSectionByControl(controlId);
      if (section && !this.props.schema.loaders?.form) {
        clearInterval(intervalId);
        setSection(section.id);
        this.scrollToField({
          controlId,
          sectionId: section.id,
        });
      }
    }, 0);
  };

  actionRefreshForm = async () => {
    const {
      params: { form_type, process_id },
      loadFrom,
    } = this.props;

    this.setState({
      anchoredTo: { controlId: undefined, sectionId: undefined },
    });
    loadFrom(form_type, process_id);
  };

  actionDetailNotify = (detail: detailObject) => {
    this.notify(detail.message);
  };

  scrollToSectionError = (errorField: ErrorField, sectionId: string) => {
    const { setSection, incrimentToSend, schema } = this.props;

    incrimentToSend();
    if (schema.section !== sectionId) setSection(sectionId);

    this.scrollToField(
      {
        controlId: errorField.controlId,
        sectionId,
      },
      { errorField },
    );

    if (errorField.error.message && !isObject(errorField.error.message)) {
      this.notify(errorField?.error?.message);
    }
  };

  render() {
    const {
      schema,
      loaders,
      extRules,
      extActions: Actions,
      params,
    } = this.props;
    const { errorField, loader } = this.state;

    if (isEmptyObject(schema.form) === false) {
      const { form } = schema;
      const readonly = schema.readonly || schema.mode === 'suspended';
      const sct = visibleControls(schema);

      const valuesSection = getSelection(sct, schema.values, schema.section);

      const sections = calcPercentSidebar(
        sct,
        schema.values,
        schema.checkedPanel,
      );
      form.mentor_confirmed =
        typeof schema.mentor_confirmed !== 'undefined'
          ? schema.mentor_confirmed
          : null;

      // TODO: double sections after Destructuring
      const sectionsProps = this.props.sections;
      const allSections = schema.form.sections;

      let errorFields = this.collectSectionErrors(valuesSection);

      if (errorField?.error) {
        errorFields = [
          {
            controlId: errorField.controlId,
            message: errorField.error.message,
            isError: true,
            isFrontValidation: errorField.error.isFrontValidation,
          },
          ...errorFields,
        ];
      }
      const firstSectionErrorId = errorFields[0] && errorFields[0].controlId;

      let rowSection;
      if (valuesSection && this.props.sections) {
        rowSection = this.props.sections.find(
          (section) => section.id === valuesSection.id,
        );
      }

      const sectionsWOHidden = sections.filter((sect) => !sect.hidden);

      const actionsPropsWithoutHiddenSections = {
        sectionIndex: sectionsWOHidden.findIndex(
          ({ id }) => id === this.props.schema.section,
        ),
        sectionCount: sectionsWOHidden.length,
      };

      return (
        <div id="content" className="nopad">
          <Preloader isLoading={!!loaders?.form || loader}>
            <div className="reportbox">
              <div className="reportbox-content-row">
                <div className="reportbox-sidebar">
                  <div className="reportbox-sidebar-heading">
                    <span className="reportbox-sidebar-heading-title">
                      {extRules.getFormTitle(params)}
                    </span>
                    {extRules.getFormSubtitle && (
                      <span className="reportbox-sidebar-heading-subtitle">
                        {extRules.getFormSubtitle(schema.form, schema.values)}
                      </span>
                    )}
                  </div>
                  <div className="reportbox-sidebar-menu">
                    <Sidebar
                      items={sectionsWOHidden}
                      status={schema.status}
                      value={schema.section}
                      isClose={schema.form.close && schema.status === 0}
                      onSelected={this.onSelected}
                    />
                  </div>
                </div>
                <div className="reportbox-content-viewport">
                  <Content
                    section={valuesSection}
                    sections={sectionsProps}
                    allSections={allSections}
                    rowSection={rowSection}
                    api={
                      this.props?.api &&
                      Object.assign(this.props?.api, {
                        moduleApi: this.props?.moduleApi ?? {},
                      })
                    }
                    extRules={extRules}
                    disableNumber={schema.form.enabled}
                    status={schema.status}
                    values={schema.values}
                    countToSend={schema.countToSend}
                    readonly={readonly}
                    visited={schema.visited}
                    allVisited={schema.allVisited}
                    errors={schema.errors}
                    firstErrorId={firstSectionErrorId}
                    dispatcher={this.dispather}
                    tags={schema.tags}
                    projects={schema.projects}
                    company={schema.company}
                    cities={schema.cities}
                    countries={schema.countries}
                    flows={schema.flows}
                    urlParams={{
                      direction_id: schema?.direction_id,
                      request_id: schema?.request_id,
                    }}
                    controlMode={schema.control_mode}
                    userRole={schema.user.userRole}
                    changedControls={schema.changed_controls}
                    // TODO: Убрать как сделают одинаковые запрос для динамического списка черех json схему!
                    dynamicOptions={schema?.dynamicOptions}
                    // Прокидывать все действия с формой нужно теперь тут. Все экшены должны начинаться с actionName
                    formActions={{
                      actionRefreshForm: this.actionRefreshForm,
                      actionScrollToField: this.actionScrollToField,
                      actionDetailNotify: this.actionDetailNotify,
                    }}
                    remoteControls={this.props.remoteControls}
                  />
                </div>
              </div>

              <Progress
                sections={form.sections}
                checkPanel={this.getCheckedPanels()}
                sectionPercent={sections}
              />
              <PersonalData
                userRole={schema.user.userRole}
                senderData={schema.senderData}
              />

              <Actions
                // eslint-disable-next-line react/jsx-no-bind
                onPDF={
                  this.props.onReportPDF
                    ? this.props.onReportPDF.bind(this)
                    : this.onReportPDF
                }
                // eslint-disable-next-line react/jsx-no-bind
                onLoadPDF={
                  this.props.onLoadPDF
                    ? this.props.onLoadPDF.bind(this)
                    : this.onLoadPDF
                }
                // eslint-disable-next-line react/jsx-no-bind
                onLoadContract={
                  this.props.onLoadContract
                    ? this.props.onLoadContract.bind(this)
                    : this.onLoadContract
                }
                onApplicationPdfDownload={this.onApplicationPdfDownload}
                schema={form}
                extRules={extRules}
                mode={schema.mode}
                status={schema.status}
                process_id={params.process_id}
                form_type={params.form_type}
                userRole={schema.user.userRole}
                user={schema.user}
                formKind={schema?.form_kind}
                // eslint-disable-next-line react/jsx-no-bind
                onSend={
                  this.props.onValidateAndSend
                    ? this.props.onValidateAndSend.bind(this)
                    : this.onValidateAndSend
                }
                // eslint-disable-next-line react/jsx-no-bind
                onCopy={
                  this.props.onCopy ? this.props.onCopy.bind(this) : this.onCopy
                }
                // eslint-disable-next-line react/jsx-no-bind
                onDraft={
                  this.props.onDraft
                    ? this.props.onDraft.bind(this)
                    : () => history.push('/company')
                }
                // eslint-disable-next-line react/jsx-no-bind
                onDocument={
                  this.props.onDocument
                    ? this.props.onDocument.bind(this)
                    : this.onDocument
                }
                // eslint-disable-next-line react/jsx-no-bind
                onRevoke={
                  this.props.onRevoke
                    ? this.props.onRevoke.bind(this)
                    : this.onRevoke
                }
                // eslint-disable-next-line react/jsx-no-bind
                onReturn={
                  this.props.onReturn
                    ? this.props.onReturn.bind(this)
                    : this.onReturn
                }
                // eslint-disable-next-line react/jsx-no-bind
                onDelete={
                  this.props.onDelete
                    ? this.props.onDelete.bind(this)
                    : this.onDelete
                }
                // eslint-disable-next-line react/jsx-no-bind
                onAddition={
                  this.props.onAddition
                    ? this.props.onAddition.bind(this)
                    : this.onAddition
                }
                onConfirmProcess={this.onConfirmProcess}
                isPdf={this.isPdf()}
                isVisible={isUndefined(readonly) ? true : !readonly}
                progress={countProgress({
                  sections: form.sections,
                  checkPanel: this.getCheckedPanels(),
                  sectionPercent: sections,
                })}
                // eslint-disable-next-line react/jsx-no-bind
                onLastComment={
                  this.props.onLastComment
                    ? this.props.onLastComment.bind(this)
                    : () => this.lastComment.show()
                }
                getHistory={this.props?.getHistory || nope}
                history={schema.history}
                {...actionsPropsWithoutHiddenSections}
                onSetSectionForIndex={this.onSetSectionForIndex}
              />
            </div>
          </Preloader>

          <CommentModal
            ref={(modal) => {
              this.modal = modal;
            }}
            func={this.state.func}
            data={{
              process_id: schema.process_id,
              userRole: schema.user.userRole,
              status: schema.status,
              extRules,
            }}
            isFetching={loader}
            pd_field_errors={this.state.pd_field_errors as any}
          />
          <ConfirmModal
            ref={(modal) => {
              this.confirmModal = modal;
            }}
            func={this.props.onAcceptMentorProcess}
            data={{
              process_id: schema.process_id,
              accept: false,
            }}
          />

          {isUndefined(loaders.form) && (
            <LastComment
              ref={(modal) => {
                this.lastComment = modal;
              }}
              data={{
                history: schema.history,
                status: schema.status,
                userRole: schema.user.userRole,
                loaders,
                extRules,
              }}
            />
          )}
        </div>
      );
    }

    return (
      <div id="content" className="content">
        <Preloader isLoading={!!loaders?.form || loader}>
          <div className="container-fluid container-empty">
            <h4>Заявка не существует</h4>
            <button
              type="button"
              className="btn btn-success"
              style={{ marginTop: '20px' }}
              onClick={() => history.push('/')}
            >
              Вернуться к списку заявок
            </button>
          </div>
        </Preloader>
      </div>
    );
  }
}

const ConnectProps = (WrappedComponent) => (props) =>
  class HOC extends React.Component {
    render() {
      return <WrappedComponent {...this.props} {...props()} />;
    }
  };

export default ConnectProps(Request)(() => {
  const moduleApi = new ApiClientModule();

  return {
    moduleApi,
  };
});
